import { render } from "./UpcomingEventsCards.vue?vue&type=template&id=47dc39bd"
import script from "./UpcomingEventsCards.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__